<div class="unauthorized-container">
  <div class="unauthorized-card">
    <ng-container *ngIf="hasAccess === null">
      <p class="unauthorized-message">Checking access&hellip;</p>
    </ng-container>
    <ng-container *ngIf="hasAccess === false">
      <div class="unauthorized-icon">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
          <circle cx="28" cy="28" r="28" fill="var(--unauth-bg, #fff3cd)" />
          <path d="M28 16v14" stroke="var(--unauth-icon, #b00020)" stroke-width="3" stroke-linecap="round"/>
          <circle cx="28" cy="38" r="2" fill="var(--unauth-icon, #b00020)" />
        </svg>
      </div>
      <h2>Access Denied</h2>
      <p class="unauthorized-message">{{ message }}</p>
    </ng-container>
    <ng-container *ngIf="hasAccess === true">
      <h2>Access Granted</h2>
    </ng-container>
  </div>
</div>